import React, { useEffect } from "react";
import LoginEmail from "./LoginEmail";
import "./Login.css";
import Footer from "../Footer/Footer";

/**
 * Component that displays the login page
 *
 * @return {JSX.Element} Login component JSX
 */
export default function Login() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <LoginEmail />
      <Footer tab={"login"} />
    </>
  );
}
